var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('span',{staticClass:"tag tag-item-enabled"},[_vm._v(" "+_vm._s(_vm.enabledLabel)+" ")]):_c('span',{staticClass:"tag tag-item-disabled"},[_vm._v(" "+_vm._s(_vm.disabledLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }